import React from "react";

import { refreshTokenAsync, restoreToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "./hooks";

export default function useAuth() {
  const dispatch = useAppDispatch();
  const { isLoggedIn, exp, loading, token } = useAppSelector((s) => s.auth);
  const [l, setL] = React.useState(true);

  React.useEffect(() => {
    if (exp !== undefined && !loading) {
      const i = setInterval(() => {
        const now = Date.now() / 1000;
        const timeLeft = exp - now;
        if (timeLeft <= 10 && !loading) {
          dispatch(refreshTokenAsync());
          clearInterval(i);
        }
      }, 5000);
    }
  }, [exp, dispatch, loading]);
  React.useEffect(() => {
    if (!loading && !exp && !token && !l) dispatch(refreshTokenAsync());
  }, [loading, exp, token, l]);

  React.useEffect(() => {
    dispatch(restoreToken(localStorage.getItem("jwtToken")!));
    setL(false);
  }, []);
  return { isLoggedIn, l };
}
